import { inject, InjectionToken } from '@angular/core';
import { CustomerVoiceRouterService } from '../core/cv-router.service';
import { OwnerType } from '@vendasta/smsv2';
import { AppConfigService } from '../core/app-config.service';
import { combineLatest } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { AccountGroupService, ProjectionFilter } from '@galaxy/account-group';
import { BROADLY_SMS_PIDS } from '@galaxy/sms';

export const SmsRegistrationLibraryInjectionToken = new InjectionToken('dependencies given to the sms library', {
  factory: () => {
    const customerVoiceRouterService = inject(CustomerVoiceRouterService);
    const appConfig = inject(AppConfigService);
    return {
      ownerId$: customerVoiceRouterService.accountGroupId,
      ownerType: OwnerType.OWNER_TYPE_ACCOUNT_GROUP,
      subaccountID$: appConfig.appConfig.pipe(map((config) => config.twilioSubaccountId)),
    };
  },
});

export const SmsContextLibraryInjectionToken = new InjectionToken('sms context for customer voice client', {
  factory: () => {
    const customerVoiceRouterService = inject(CustomerVoiceRouterService);
    const appConfig = inject(AppConfigService);
    const accountGroupService = inject(AccountGroupService);

    const accountGroupId$ = customerVoiceRouterService.accountGroupId;
    const config$ = appConfig.appConfig;

    const projectionFilter = new ProjectionFilter();
    projectionFilter.accountGroupExternalIdentifiers = true;

    const accountGroup$ = accountGroupId$.pipe(
      switchMap((accountGroupId) => accountGroupService.get(accountGroupId, projectionFilter)),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

    return {
      ownerId$: accountGroupId$,
      ownerType: OwnerType.OWNER_TYPE_ACCOUNT_GROUP,
      featureFlagInfo$: config$.pipe(
        map((config) => ({
          partnerId: config?.partnerId,
          marketId: config?.marketId,
        })),
      ),
      sendsViaBroadly$: combineLatest([config$, accountGroup$]).pipe(
        map(
          ([config, ag]) =>
            BROADLY_SMS_PIDS.includes(config?.partnerId) && !!ag?.externalIdentifiers?.customerIdentifier,
        ),
      ),
    };
  },
});
